import { capitalizeFirstLetter } from 'BreetHelpers';
import { memo } from 'react';

export const FiatInputErrorComponent = memo(({ errorMessage, message }: { errorMessage?: string; message?: string }) => {
	const inputMessage = errorMessage?.length ? errorMessage : message;

	const inputMessageClass = errorMessage ? 'fiat_input_error' : 'fiat_input_message';

	return <>{!!inputMessage && <span className={inputMessageClass}>{capitalizeFirstLetter(inputMessage)}</span>}</>;
});

FiatInputErrorComponent.displayName = 'FiatInputErrorComponent';
